import { KnifeMilitaryIcon } from './KnifeMilitaryIcon';

/**
 * author: Simran
 * id D31C18C1-776C-4444-9A12-F2BD366CF929
 * name knife-military
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/knife-military.svg
 * tags
 * - Gaming / RPG 
 */
export const DaggerIcon = KnifeMilitaryIcon;
export default DaggerIcon